import script from "./Token.vue?vue&type=script&setup=true&lang=js"
export * from "./Token.vue?vue&type=script&setup=true&lang=js"

import "./Token.vue?vue&type=style&index=0&id=3cc021b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc021b0"]])

export default __exports__